import React from 'react';
import ModalTitle from '@shared/components/inputs/text-fields/ModalTitle';
import { Segments } from '@domain/segments/segments.types';
import { isBudgetManagerTagGroup } from '@domain/budget-manager/budget-manager.utils';
import { SEGMENTS_MODAL_TEXTS } from '../segments-modal.constants';
import { withSegmentsModal } from '../segments-modal.hocs';

interface SegmentsModalTitleProps {
    setModalSelectedGroup: ({ group: Segments }) => void;
    modalSelectedGroup: Segments;
}

export const SegmentsModalTitle = withSegmentsModal(({
    setModalSelectedGroup,
    modalSelectedGroup,
}: SegmentsModalTitleProps) => (
    <ModalTitle
        placeholder={SEGMENTS_MODAL_TEXTS.inputNameGroupPlaceholder}
        value={modalSelectedGroup?.name}
        onChange={({ target }) => {
            setModalSelectedGroup({ group: { ...modalSelectedGroup, name: target.value } });
        }}
        readOnly={isBudgetManagerTagGroup(modalSelectedGroup?.slug)}
    />
));
